import { render, staticRenderFns } from "./learning-view.vue?vue&type=template&id=aa4eba20&scoped=true"
import script from "./learning-view.vue?vue&type=script&lang=ts"
export * from "./learning-view.vue?vue&type=script&lang=ts"
import style0 from "./learning-view.vue?vue&type=style&index=0&id=aa4eba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4eba20",
  null
  
)

export default component.exports